import React from "react";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Form, Button, Card, Space } from "antd";
import FormFields from "./FormFields";
import { addSpecialty } from "../../../redux/slices/specialtys/specialtysThunk";

const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 12 },
};

const tailLayout = {
  wrapperCol: { offset: 8, span: 16 },
};

const AddSpecialtiesPage = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const history = useHistory();

  const onFinish = (values) => {
    const formattedValues = {
      name: values.name,
      abreviation: values.abreviation,
    };
    dispatch(addSpecialty(formattedValues)).then ((result) => {
      if (addSpecialty.fulfilled.match(result)) {
        history.push("/spécialités");
      }
    }
    );
  };

  const onReset = () => {
    form.resetFields();
  };

  const navigateTo = (path) => {
    history.push(path);
  };

  return (
    <div>
      <Card
        bordered
        className="criclebox tablespace mb-24"
        title="Ajouter une spécialité"
      />
      <Card bordered={false}>
        <Form
          {...layout}
          form={form}
          name="control-hooks"
          onFinish={onFinish}
        >
          <FormFields />
          <Form.Item {...tailLayout}>
            <Space size="small">
              <Button type="primary" htmlType="submit">
                Enregistrer
              </Button>
              <Button htmlType="button" onClick={onReset}>
                Reset
              </Button>
              <Button type="link" htmlType="button" onClick={() => navigateTo("/spécialités")}>
                Annuler
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default AddSpecialtiesPage;
